import { ImgHTMLAttributes, useEffect, useState } from 'react';

const fallbackImageLink = 'https://pkgtour.naver.com/assets/public/mobile/commons/images/blank.png';

interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  alt: string;
  src: string;
  isLazyLoad?: boolean;
}

const ImageWrapper = ({ alt, src, isLazyLoad = true, ...imageProps }: ImageProps) => {
  const [isError, setIsError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!isLazyLoad) {
      return;
    }

    // SSR 시, img onLoad, onError 이벤트가 발화하지 않아 아래와 같은 방법으로 처리
    const lazyLoadImage = new Image();

    lazyLoadImage.src = src;
    lazyLoadImage.onload = () => {
      if (lazyLoadImage.naturalWidth === 0 && lazyLoadImage.naturalHeight === 0) {
        setIsError(true);
      }
      setIsLoaded(true);
    };
    lazyLoadImage.onerror = () => {
      setIsError(true);
    };
  }, [isLazyLoad, src]);

  if (isError || (isLazyLoad && !isLoaded)) {
    return <img {...imageProps} alt={alt} src={fallbackImageLink} />;
  }

  return <img {...imageProps} alt={alt} src={src} />;
};

export { ImageWrapper as Image };
